<script lang="ts">
  import { get } from "svelte/store";
  import {
    accessToken,
    errorMessage,
    logout,
    currentPage,
    selectedLanguageCode,
    sum,
    Views,
  } from "./store";
  import { StorageKeys } from "./enums/localStorageKeys";
  import { onMount } from "svelte";
  import { LocalizationTexts, localizedTexts } from "./texts";

  let texts: LocalizationTexts = localizedTexts.de;

  let hostedPageId: string;
  let selected: "paypal" | "creditcard" | "sepa";

  let sepaExpressReady = false;
  let _sepaExpress;
  let mounted = false;
  let givenName: string = "";
  let familyName: string = "";
  let iban: string = "";
  let emailAddress: string = "";

  onMount(() => {
    mounted = true;
    if (sepaExpressReady) {
      loadSepaExpressElements();
    }
    selectedLanguageCode.subscribe((language) => {
      texts = localizedTexts[language];
    });
  });

  function stripeLoaded() {
    sepaExpressReady = true;
    if (mounted) {
      loadSepaExpressElements();
    }
  }

  function loadSepaExpressElements() {
    _sepaExpress = sepaExpress;
  }

  async function initSepaExpress() {
    hostedPageId = await getHostedPageId();
    if (!hostedPageId) return;
    _sepaExpress.init(hostedPageId);
    _sepaExpress.finish(() => {
      currentPage.set(Views.success);
    });
  }

  function getHostedPageId(): Promise<string> {
    const settings = JSON.parse(localStorage.getItem("demoShopSettings")) ?? {};
    if (!!hostedPageId) return;
    const amount = Math.round(get(sum) * 100 * 100) / 100;
    const body = JSON.stringify(getCreateHostedPageRequestBody(amount));
    return fetch(`FX_HOST_SAND/api/services/v2/HostedPages`, {
      method: "post",
      headers: new Headers([
        ["Authorization", `Bearer ${get(accessToken)}`],
        ["Content-Type", "application/json"],
      ]),
      body,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          if (res.status === 401) {
            logout;
          }
          errorMessage.set(
            (res.statusText ?? "Error occurred") +
              " - wrong merchant- or connectorId?"
          );
        }
      })
      .then((res) => {
        if (!res) return undefined;
        hostedPageId = res.hostedPage.id;
        return hostedPageId;
      });
  }

  function getCreateHostedPageRequestBody(amount: number) {
    return {
      mandate: {
        connectorId: localStorage.getItem(StorageKeys.ConnectorId),
        bankAccount: {
          customer: {
            MerchantId: localStorage.getItem(StorageKeys.MerchantId),
            languageCode: get(selectedLanguageCode),
          },
        },
        approvalBy: "dynamic",
        currencyCode: "EUR",
        amount,
      },
      type: "createMandate",
    };
  }
</script>

<svelte:head>
  <script src="FX_HOST_SAND/sepaexpress.js" on:load={stripeLoaded}></script>
</svelte:head>

<div
  class="max-w-full"
>
  <h3 class="text-2xl font-extrabold text-black">
    {texts.checkout}
  </h3>
  <div class="my-10">
    <span class="text-gray-400 font-bold">{texts.paymentMethod}:</span>
    <div class="mt-3 flex flex-col gap-y-2">
      <label class="inline-flex items-center">
        <input
          type="radio"
          class="form-radio"
          name="accountType"
          value="busines"
          on:click={() => (selected = "sepa")}
          on:click={initSepaExpress}
        />
        <span class="ml-3 font-bold text-gray-700 flex text-lg">
          <span class="w-8 flex justify-start">
            <img src="assets/icons/sepa.svg" class="h-6" alt="creditcard" />
          </span>SEPA Direct Debit</span
        >
      </label>
      {#if !selected}
        <span class="flex flex-col gap-y-2">
          <label class="inline-flex items-center opacity-50">
            <input
              type="radio"
              class="form-radio"
              name="accountType"
              value="personal"
              on:click={() => (selected = "creditcard")}
            />
            <span class="ml-3 font-semibold text-gray-700 flex items-center">
              <span class="w-8 flex justify-start">
                <img
                  src="assets/icons/creditcard.png"
                  class="h-6"
                  alt="creditcard"
                />
              </span>

              Credit Card</span
            >
          </label>
          <label class="inline-flex items-center opacity-50">
            <input
              type="radio"
              class="form-radio"
              name="accountType"
              value="busines"
              on:click={() => (selected = "paypal")}
            />
            <span class="ml-3 font-semibold text-gray-700 flex items-center">
              <span class="w-8 flex justify-start">
                <img src="assets/icons/paypal.png" class="h-6" alt="paypal" />
              </span>
              PayPal</span
            >
          </label>
        </span>
      {/if}
    </div>
  </div>
  <script src="FX_HOST_SAND/sepaexpress.js"></script>
  {#if hostedPageId && selected === "sepa"}
    <div id="sepa-express-container" style="width: 100%" />
  {/if}
</div>
